import axios from 'axios'
import { AuthTokenModel } from '../../../shared/models'
import { ExecuteLoginResponseModel } from '../../../shared/models'


export const GET_USER_PROFILE = '/profile/show'
export const LOGIN_URL = 'authentication/login'
export const LOGOUT_URL = '/authentication/logout'
export const REQUEST_PASSWORD_URL = '/authentication/reset-password/send-token'
export const RESET_PASSWORD_URL = '/authentication/reset-password/define-password'
export const REFRESH_TOKEN_URL = '/authentication/refresh-token'

interface LoginRequest {
    email: string
    password: string
}
export function login({email, password}: LoginRequest) {
    return axios.post<ExecuteLoginResponseModel>(LOGIN_URL, {email, password})
}

export function logout() {
    return axios.delete(LOGOUT_URL)
}

export function requestPassword(email: string) {
    return axios.post<{success: boolean; message: string}>(REQUEST_PASSWORD_URL, {email})
}

export function requestResetPassword(
    token: string,
    email: string,
    password: string,
    password_confirmation: string
) {
    return axios.post(RESET_PASSWORD_URL, {token, email, password, password_confirmation})
}
export function getUserByToken() {
    return axios.get<ExecuteLoginResponseModel>(GET_USER_PROFILE)
}
export function refresh_token(refresh_token: string) {
    return axios.post<AuthTokenModel>(REFRESH_TOKEN_URL, {refresh_token})
}
